import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AppText from "../../../_shared/components/AppText";
import SharedPage from "../SharedPages";
import mainImage from "../../../../assets/images/system/contenitori.png";
// import SystemFinishesPage from "../SharedPages/finishesPage";

import list from "./list";
import SystemPickPoint from "../../../_shared/components/SystemPickPoint";
import SystemFinishesPage from "../SharedPages/finishesPage";
import CloseIcon from "../../../_shared/components/CloseIcon";
import HeaderActions from "../../../_shared/components/HeaderActions";

// ----------------------------------------------------------------------------

export default function StorageUnits(props) {
  const { setSplash } = props;
  useEffect(() => setSplash(false), []);

  const [selectedId, setSelectedId] = useState();
  const [selectedFinishes, setSelectedFinishes] = useState();
  function goTo(id) {
    setSelectedId(id);
  }
  const navigate = useNavigate();
  function toSystem() {
    navigate("/System#modules");
  }

  return selectedId ? (
    <SharedPage
      composition={list.filter((x) => x?.id === selectedId)?.[0]}
      onClose={() => setSelectedId()}
    />
  ) : selectedFinishes ? (
    <SystemFinishesPage
      finishesId={selectedFinishes}
      onClose={() => setSelectedFinishes()}
    />
  ) : (
    <div
      style={{
        height: "90vh",
        aspectRatio: 1.33,
        position: "absolute",
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        margin: "auto",
      }}
    >
      <img
        src={mainImage}
        style={{
          height: "100%",
          width: "100%",
          objectFit: "contain",
        }}
        alt=""
      ></img>
      <div
        style={{
          position: "absolute",
          top: 10,
          left: "93%",
          height: 40,
          width: 40,
        }}
      >
        <CloseIcon alt="" />
      </div>
      <div
        style={{
          position: "absolute",
          top: 10,
          left: "85%",
          height: 40,
          width: 40,
        }}
      >
        <HeaderActions alt="" />
      </div>
      <SystemPickPoint
        top={0}
        left={93}
        icon
        onPress={() => toSystem()}
      ></SystemPickPoint>
      <SystemPickPoint
        top={34}
        left={15}
        onPress={() => goTo(1)}
      ></SystemPickPoint>
      <SystemPickPoint
        top={30}
        left={34}
        onPress={() => goTo(2)}
      ></SystemPickPoint>
      <SystemPickPoint
        top={20}
        left={55}
        onPress={() => goTo(3)}
      ></SystemPickPoint>
      <SystemPickPoint
        top={15}
        left={72}
        onPress={() => goTo(4)}
      ></SystemPickPoint>

      <SystemPickPoint
        top={81}
        left={32}
        small
        onPress={() => setSelectedFinishes([1, 2, 3])}
      ></SystemPickPoint>
      <SystemPickPoint
        top={81}
        left={50}
        small
        onPress={() => setSelectedFinishes([1, 2, 3])}
      ></SystemPickPoint>
      <SystemPickPoint
        top={81}
        left={67}
        small
        onPress={() => setSelectedFinishes([4, 5, 7])}
      ></SystemPickPoint>
      <SystemPickPoint
        top={81}
        left={86}
        small
        onPress={() => setSelectedFinishes([4, 5])}
      ></SystemPickPoint>
    </div>
  );
}
